export default [
  {
    path: "/users",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "users_list_admin",
        path: "admins",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Users", to: "users_list_admin" }],
          permission: "user:view",
          admins: true,
          title: "Users",
        },
      },
      {
        name: "users_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Users", to: "users_list" }],
          permission: "user:view",
          admins: false,
          title: "Users",
        },
      },
      {
        name: "users_create",
        path: "novo/:cliente_id?",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Users", to: "users_list" }],
          permission: "user:create",
          title: "Users - Cadastro",
        },
      },
      {
        name: "users_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Users", to: "users_list" }],
          permission: "user:edit",
          title: "Users - Edição",
        },
      },
    ],
  },
  {
    path: "/profile",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "profile",
        path: "",
        component: () => import("./pages/Profile"),
        meta: {
          breadcrumbs: [{ label: "Perfil", to: "profile" }],
          title: "Perfil",
        },
      },
    ],
  },
];
